import { TeethNumberingSystem } from '@modules/teeth-diagram/models/teeth-numbering-system.enum';
import { LoggerService } from '@core/services/logger/logger.service';
import type { Maybe } from '@/types/globals';

export const isTeethNumberingSystemValid = (teethNumberingSystem: any): teethNumberingSystem is TeethNumberingSystem => {
	return [TeethNumberingSystem.FDI, TeethNumberingSystem.ADA, TeethNumberingSystem.Quadrant].includes(teethNumberingSystem);
};

export const getTeethNumberingSystem = ({
	forceTeethNumberingSystem,
	teethNumberingSystemFromRx,
	teethNumberingSystemFromUserSettings,
	isDoctor,
	logger
}: {
	forceTeethNumberingSystem?: TeethNumberingSystem;
	teethNumberingSystemFromRx?: TeethNumberingSystem;
	teethNumberingSystemFromUserSettings: Maybe<TeethNumberingSystem>;
	isDoctor: boolean;
	logger: LoggerService;
}): TeethNumberingSystem => {
	let result: TeethNumberingSystem;

	if (forceTeethNumberingSystem != null && forceTeethNumberingSystem !== undefined) {
		result = forceTeethNumberingSystem;
	} else if (!isDoctor && teethNumberingSystemFromRx != null) {
		result = teethNumberingSystemFromRx;
	} else {
		result = teethNumberingSystemFromUserSettings as any;
	}

	if (!isTeethNumberingSystemValid(result)) {
		logger.error(`Invalid teeth numbering system ${teethNumberingSystemFromUserSettings}`, {
			module: new Error().stack as string
		});

		result = TeethNumberingSystem.ADA;
	}

	return result;
};
